// components/Bar.js
// Yuan Wang
// Copyright American Marine Research Company LLC 2019

import React, { Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import MenuIcon from '@material-ui/icons/Menu';
import Hidden from '@material-ui/core/Hidden';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import { MenuLogo } from '../components/Logo'
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  root: {
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    marginTop: theme.spacing(2) + 4
  },
  drawerContainer: {
    flexGrow: 1,
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2),
  },
  sideButtonText: {
    textAlign: 'left',
    color: 'white',
    fontWeight: 700,
  },
  barButtonText: {
    textAlign: 'left',
    fontWeight: 700,
  },
  sideButton: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(0),
    marginBottom: 4,
    marginRight: theme.spacing(2)
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex'
  },
  appBar: {
    // boxShadow: "none",
    // background: "linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);"
  }
}));

const LOGIN_LINK = "/login"
const SIGNUP_LINK = "/#updates" // LOGIN_LINK + "?id=nosurvey"

const LINKS = [
  {
    name: "Contact",
    href: "/contact"
  },
  {
    name: "login",
    href: LOGIN_LINK
  }
]


function ElevationScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}


export default function Bar({ position, ...props }) {
  const classes = useStyles();
  const [ drawerOpen, setDrawerOpen ] = useState(false)
  const { window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return (
    <Fragment>
      <ElevationScroll {...props}>
        <AppBar 
          position={ position }
          color="inherit" 
          className={classes.appBar}>
          <Toolbar>
            <Hidden only={["sm", "md", "lg", "xl"]}>
              <IconButton 
                onClick={() => setDrawerOpen(!drawerOpen)} 
                edge="start" 
                className={classes.menuButton} 
                color="inherit" 
                aria-label="menu">
                <MenuIcon />
              </IconButton>
            </Hidden>

            <Hidden only={["sm", "md", "lg", "xl"]}>
              <Typography 
                variant="h6" 
                className={classes.title}>
                <a href='/'>
                  <MenuLogo/>
                </a>
              </Typography>
            </Hidden>

            <Hidden only={["xs"]}>
              <Typography 
                variant="h6" 
                className={classes.title}>
                <a href="/">
                  <MenuLogo/>
                </a>
              </Typography>
            </Hidden>

            <Hidden only={["xs"]}>
              { trigger ? 
                <Fragment>
                  <Button 
                    className={classes.sideButton}
                    href={'/contact'}
                    // variant="contained"
                    // color="secondary"
                    >
                    Contact
                  </Button>
                  <Button 
                    className={classes.sideButton}
                    href={LOGIN_LINK}
                    color="inherit">
                    Login
                  </Button>
                </Fragment>
              :
              LINKS.map(({ name, href }) => (
                <Button 
                  key={name}
                  className={classes.sideButton}
                  href={href}
                  color="inherit">
                  <Typography 
                    variant="body1" 
                    component="p"
                    className={classes.barButtonText}>
                    {name}
                  </Typography>
                </Button>
              ))}
            </Hidden>
            
          </Toolbar>
        </AppBar>
      </ElevationScroll>

      <Drawer 
        open={drawerOpen} 
        className={classes.drawer}
        onClose={() => setDrawerOpen(false)}>
        <div 
          className={classes.drawerContainer}>
          <div 
            justify='space-between'
            align="flex-start"
            className={classes.headerRow}>
            <a href='/'>
              <MenuLogo light/>
            </a>
            
            <IconButton 
              onClick={() => setDrawerOpen(false)}
              className={classes.button} 
              aria-label="close">
              <CloseIcon style={{ fontSize: 30, color: 'white' }}/>
            </IconButton>
          </div>
          <br/>
          <br/>
          {LINKS.map(({ name, href }) => (
            <Button 
              key={name}
              className={classes.sideButton}
              href={href}
              color="inherit">
              <Typography
                variant="h4" 
                component="h3"
                className={classes.sideButtonText}>
                {name}
              </Typography>
            </Button>
          ))}
        </div>
      </Drawer>
    </Fragment>
  );
}

